import { FormGroup, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { DepositFormFiller } from './form-filler.factory';
import { UserFullInfo } from 'src/app/services/auth/login/login.models';

export class InterkassaPaymentIq implements DepositFormFiller {
    public fillForm(form: UntypedFormGroup, userInfo: UserFullInfo) {
        console.log("interkass form filler")
        const date = new Date();
        const offset = date.getTimezoneOffset();
        const timezone = Intl.DateTimeFormat()?.resolvedOptions()?.timeZone;
        const browserInfoFormGroup = new FormGroup({
            browserAcceptHeader: new UntypedFormControl("*/*"),
            browserJavaEnabled: new UntypedFormControl(true),
            browserLanguage: new UntypedFormControl(navigator.language),
            browserColorDepth: new UntypedFormControl(screen.colorDepth),
            browserScreenHeight: new UntypedFormControl(screen.height),
            browserScreenWidth: new UntypedFormControl(screen.width),
            browserTZ: new UntypedFormControl(timezone),
            browserUserAgent: new UntypedFormControl(navigator.userAgent),
        });
        form.addControl('browserInformation', browserInfoFormGroup);

        return
    }
}
